import {PropertyBase} from "./PropertyBase";
import {PDFControlBase} from "../Core/PDFControlBase";



export class FontStylesProperty extends PropertyBase{


    constructor(toolItem:PDFControlBase, OptionsOverWrite:any=null)
    {
        super(toolItem,'',OptionsOverWrite);
    }


    protected InternalGetElement(): JQuery {
        let selectedOption=this.GetOptionValue();
        let $buttonGroup=jQuery(`<div class="btn-group"></div>`);
        $buttonGroup.append(this.GetButton('fa fa-bold','font-weight','bold'));
        $buttonGroup.append(this.GetButton('fa fa-italic','font-style','italic'));
        return $buttonGroup;
    }

    public GetButton(className:string,styleName:string,value:string){
        let active=this.GetOptionValue(styleName)==''?'':'active';

        let $button=jQuery(`<button class="btn btn-default ${className} ${active}"></button>`);
        $button.click(()=>{
           if($button.is('.active'))
           {
               $button.removeClass('active');
               this.SetOptionValue('',styleName);
           }else{
               $button.addClass('active');
               this.SetOptionValue(value,styleName);
           }
        });

        return $button;
    }


    protected InternalGenerationCompleted($element: JQuery) {
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }



}


interface ButtonOptions{
    ClassName:string;
    Value:string;
}